module.exports = __webpack_public_path__ + "static/b1-be7d2e34012b171e1736d1b5cd61ba60.jpg";